import { Component, OnInit, AfterViewInit, OnChanges, SimpleChanges, Input, OnDestroy } from '@angular/core';
import { WidgetStatusRigionwiseStatusService } from "./service/widget-status-rigionwise-status.service";
import * as Highcharts from "highcharts";
import * as HSET from "./settings";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: 'widget-status-rigionwise-status',
  templateUrl: './widget-status-rigionwise-status.component.html',
  styleUrls: ['./widget-status-rigionwise-status.component.scss'],
  providers: [WidgetStatusRigionwiseStatusService]
})
export class WidgetStatusRigionwiseStatusComponent 
implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() OPTIONS;
  @Input() TITLE;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: WidgetStatusRigionwiseStatusService
  ) {}

  ngAfterViewInit() {
    this.getRegionwiaseStatus();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
        JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getRegionwiaseStatus();
    }
  }

  ngOnInit() {
    this.translateService.get("OVERALL_STATUS.REGION_WISE_STATUS").pipe(takeUntil(this.unsubscribe)).subscribe(text => {
      this.OPTIONS.title = this.OPTIONS.title || text;
    });
  }

  getRegionwiaseStatus() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    const options = {
      url: this.OPTIONS.api,
      params: this.FILTERS,
      query: ""
    };

    this.dataService.getData(options).pipe(takeUntil(this.unsubscribe)).subscribe(
      chartData => {
        if (chartData && Object.keys(chartData && Object.keys(chartData).length) && chartData.columns && chartData.columns.length) {
          this.chartOptions = this.dataService.createChart(
            chartData,
            this.OPTIONS
          );
        } 
        else {
          this.errorMessage = "ERROR_MSG.NO_DATA";
          this.mockChart = HSET.chartData;
        }
      },
      error => {
        this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
        this.mockChart = HSET.chartData;
      }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
